import {
  AdditionalPropertyTypeNames,
  AmenityLabels,
  AmenityName,
  PropertyTypeLabels,
  PropertyTypeName,
} from '@rx-applications/clientsite/shared/utils';

export enum FilterTypes {
  Filter = 'Filter',
  FilterGroup = 'FilterGroup',
}

export type FilterTypeName = AmenityName | PropertyTypeName;

export const FilterLabels = { ...AmenityLabels, ...PropertyTypeLabels };

export class Filter {
  label: string;
  value: boolean;

  constructor(public name: FilterTypeName) {
    this.label = FilterLabels[this.name];
  }

  get type() {
    return FilterTypes.Filter;
  }

  set checked(val: boolean) {
    this.value = val;
  }

  get checked(): boolean {
    return this.value;
  }
}

export class FilterGroup {
  private value: boolean;
  constructor(public filters: Filter[], public dependantChild?: boolean) {}

  get type() {
    return FilterTypes.FilterGroup;
  }

  get name() {
    const [firstFilter] = this.filters;
    return firstFilter.name;
  }

  set checked(val: boolean) {
    this.value = val;
  }

  get checked(): boolean {
    return this.value;
  }
}

export const orderedFilters: (Filter | FilterGroup)[] = [
  new Filter('wifi'),
  new FilterGroup([
    new Filter('parking'),
    new Filter('freeparking'),
    new Filter('onsiteparking'),
    new Filter('securedparking'),
    new Filter('evparking'),
  ]),
  new Filter('restaurant'),
  new Filter('frontdesk'),
  new Filter('accessibleoptions'),
  new Filter('businessservice'),
  new Filter('gym'),
  new Filter('swimmingpool'),
];

export const rateFilters: Filter[] = [new Filter('freecancellation')];

export const loyaltyFilters: Filter[] = [new Filter('loyaltyProgram')];

export enum FilterPageSource {
  LocationResults = 'LocationResults',
  RoomSelect = 'RoomSelect',
}

export const propertyTypeFilters: Filter[] = [
  new Filter(PropertyTypeName.Hotel),
  new Filter(PropertyTypeName.Apartment),
  new Filter(PropertyTypeName.Aparthotel),
];

export const additionalPropertyTypeFilters: Filter[] = [
  new Filter(AdditionalPropertyTypeNames.BedAndBreakfast),
  new Filter(AdditionalPropertyTypeNames.Cabin),
  new Filter(AdditionalPropertyTypeNames.Chalet),
  new Filter(AdditionalPropertyTypeNames.Cottage),
  new Filter(AdditionalPropertyTypeNames.CountryHouse),
  new Filter(AdditionalPropertyTypeNames.Guesthouse),
  new Filter(AdditionalPropertyTypeNames.Hostel),
  new Filter(AdditionalPropertyTypeNames.Homestay),
  new Filter(AdditionalPropertyTypeNames.HolidayHome),
  new Filter(AdditionalPropertyTypeNames.Inn),
  new Filter(AdditionalPropertyTypeNames.Lodge),
  new Filter(AdditionalPropertyTypeNames.Motel),
  new Filter(AdditionalPropertyTypeNames.Pension),
  new Filter(AdditionalPropertyTypeNames.Townhouse),
  new Filter(AdditionalPropertyTypeNames.Villa),
];
